import React from 'react';
import { HStack, Grid, GridItem, Box, Skeleton } from '@shared/ui';

const CartProductCardGridTemplateAreas = `
    'product-image product-name cancel'
    'product-image product-spec cancel'
    '. product-bottom cancel'
`;

export const ProductCardSkeleton: React.FC = () => {
    return (
        <Grid
            gridTemplateAreas={CartProductCardGridTemplateAreas}
            gridTemplateColumns="auto 1fr auto"
            columnGap="xs"
            rowGap="s"
            py="xxs"
            overflow="hidden"
        >
            <GridItem area="product-image">
                <Box
                    w="56px"
                    h="56px"
                    borderRadius="base"
                    bg="neutral.010"
                    overflow="hidden"
                >
                    <Skeleton
                        w="100%"
                        h="100%"
                        startColor="neutral.020"
                        endColor="neutral.040"
                    />
                </Box>
            </GridItem>
            <GridItem area="product-name">
                <Skeleton
                    w="100%"
                    h="100%"
                    startColor="neutral.020"
                    endColor="neutral.040"
                />
            </GridItem>
            <GridItem area="product-spec">
                <Skeleton
                    w="100%"
                    h="100%"
                    startColor="neutral.020"
                    endColor="neutral.040"
                />
            </GridItem>
            <GridItem area="product-bottom">
                <Grid gridTemplateAreas="'quantity price'">
                    <GridItem area="quantity">
                        <Skeleton
                            w="100%"
                            h="100%"
                            startColor="neutral.020"
                            endColor="neutral.040"
                        />
                    </GridItem>
                    <GridItem area="price" alignContent="center">
                        <HStack
                            justifySelf="end"
                            gap="xs"
                            color="neutral.120"
                            fontWeight="bold"
                            fontSize="sm"
                            flexDirection="row-reverse"
                            alignItems="flex-end"
                        >
                            <Skeleton
                                w="100%"
                                h="100%"
                                startColor="neutral.020"
                                endColor="neutral.040"
                            />
                        </HStack>
                    </GridItem>
                </Grid>
            </GridItem>
            <GridItem area="cancel" />
        </Grid>
    );
};
